/**
 * Converts the legacy package cart permalinks into one-product add-to-cart
 * submissions. Each card already ends its permalink with the matching product
 * variant, so this preserves the package-to-variant mapping while allowing
 * Shopify to record a normal cart addition.
 */
const packageButtons = document.querySelectorAll('.tsre-bundle-card .cta');

for (const button of packageButtons) {
  button.addEventListener('click', (event) => {
    const href = button.getAttribute('href') || '';
    const lineItems = [...href.matchAll(/(\d+):\d+/g)];
    const variantId = lineItems.at(-1)?.[1];

    if (!variantId) return;

    event.preventDefault();

    const form = document.createElement('form');
    form.method = 'post';
    form.action = `${window.Shopify?.routes?.root || '/'}cart/add`;
    form.hidden = true;

    const variantInput = document.createElement('input');
    variantInput.type = 'hidden';
    variantInput.name = 'id';
    variantInput.value = variantId;

    const quantityInput = document.createElement('input');
    quantityInput.type = 'hidden';
    quantityInput.name = 'quantity';
    quantityInput.value = '1';

    const returnToInput = document.createElement('input');
    returnToInput.type = 'hidden';
    returnToInput.name = 'return_to';
    returnToInput.value = Theme.routes.cart_url || `${window.Shopify?.routes?.root || '/'}cart`;

    form.append(variantInput, quantityInput, returnToInput);
    document.body.append(form);
    form.submit();
  });
}
